import { Box, Image, Text, Heading, Badge } from '@chakra-ui/react'
import { Link, useHistory } from 'react-router-dom'
import placeholder from '../multimedia/placeholder.jpg'
import { StarIcon, CalendarIcon } from '@chakra-ui/icons'
import { MdLocationOn } from 'react-icons/md'


function CarCard(props) {

    const { car } = props

    const replaceImage = (error) => {
        error.target.src = placeholder;
    }

    let history = useHistory()

    function changeLocation(placeToGo) {
        history.push(placeToGo, { replace: true });
        window.scrollTo(0, 0);
    }

    return (

        <Box
            bg={'white'}
            maxW="350px"
            maxH={"550px"}
            height={"full"}
            borderWidth="1px"
            rounded="lg"
            shadow="lg"
            className='miniCarIcon'
            position="relative">

            <Link to={`/car/${car.id}`} onClick={() => changeLocation(`/car/${car.id}`)}>
                {car.nDestacado === 1 &&
                    <Badge colorScheme='easycar1' variant={"solid"} fontSize='1em' position={"absolute"} margin={"3px"}>
                        <StarIcon color={"yellow.500"} />   Destacado
                    </Badge>
                }
                {car.nDestacado === 2 &&
                    <Badge colorScheme='orange' variant={"solid"} fontSize='1em' position={"absolute"} margin={"3px"}>
                        <CalendarIcon />   Reservado
                    </Badge>
                }
                {car.nDestacado === 3 &&
                    <Badge colorScheme='yellow' variant={"solid"} fontSize='1em' position={"absolute"} margin={"3px"}>
                       $   Outlet
                    </Badge>
                }
                {car.nDestacado === 4 &&
                    <Badge colorScheme='red' variant={"solid"} fontSize='1em' position={"absolute"} margin={"3px"}>
                        %   Promoción
                    </Badge>
                }
                <Image alt={`Preview ${car.cMarca}`} src={`${car.urlFotoDelantera}`} bg="gray.200" fit={'contain'} align={'center'} w={'100%'} h={'300px'} onError={replaceImage}  />
                <Box p="6" minH={"230px"}>
                    <Heading as={'h5'} size='md'>{car.cMarca.toUpperCase()} {car.cModelo.toUpperCase()} {car.nAnio}</Heading>
                    <Text>
                         - {car.cTraccion} - {car.nMillaje.toLocaleString('en-US')} Millas
                    </Text>
                    <Text color={"green"} as={"b"} >Precio de venta: </Text><Text> ${car.nPrecioVenta.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})} + IVA</Text>
                    <Text>Anticipo desde: {(car.nAnticipo*100).toLocaleString('en-US')}%*</Text>
                    <Text fontSize={"xs"}>Monto de anticipo, sujeto a precalificación</Text>
                    { car.cAgencia &&
                        <Text> <MdLocationOn style={{ display: 'inline'}}  /> {car.cAgencia}</Text>

                    }
                    <Text>Garantía de 45 días incluida</Text>
                </Box>
            </Link>
        </Box >
    )
}

export default CarCard